<template>
    <div>
        <div class="vod-summary-title">
            Wybierz pakiet
        </div>
        <div
            class="livestream-bundle"
            @click="selectBundle(conference)"
            :class="{
                '-selected': isSelected(conference.uuid),
                '-purple': !isMobile
            }"
        >
            <div v-if="!isMobile" class="bundle-subtitle">
                Najczęściej wybierany
            </div>
            <CheckBox
                v-if="!isMobile"
                :readOnly="true"
                color="purple"
                :value="isSelected(conference.uuid)"
            />
            <div v-if="!isMobile" class="webinars-grid">
                <div
                    class="grid-webinar"
                    v-for="webinar in conferenceWebinars"
                    :key="webinar.uuid"
                >
                    <img :src="webinar.thumbnail" />
                </div>
            </div>
            <div class="summary-list">
                <h3>Bilet na całą e-konferencję</h3>
                <ul>
                    <li>Dostęp do wszystkich wydarzeń na żywo</li>
                    <li>Dostęp do nagrań z e-konferencji</li>
                    <li>Dostęp do nagrań z e-konferencji</li>
                    <li>Zaświadczenia o udziale w e-szkoleniu</li>
                </ul>
                <div class="item-price">
                    <div>Cena:</div>
                    <div class="-price-crossed" v-if="conference.old_cost">
                        {{
                            `${$Utils.getPriceFromBackend(
                                conference.old_cost + 199
                            )}zł`
                        }}
                    </div>
                    <div
                        class="black"
                        :class="{
                            '-price-selected': isSelected(conference.uuid)
                        }"
                    >
                        {{
                            `${$Utils.getPriceFromBackend(
                                conference.cost + 199
                            )}zł`
                        }}
                    </div>
                </div>
            </div>
        </div>
        <div
            class="livestream-bundle"
            @click="selectBundle(webinar)"
            :class="{ '-selected': isSelected(webinar.uuid) }"
        >
            <CheckBox
                v-if="!isMobile"
                :readOnly="true"
                color="apple"
                :value="isSelected(webinar.uuid)"
            />
            <div v-if="!isMobile" class="summary-image">
                <img :src="webinar.thumbnail" />
            </div>
            <div class="summary-list">
                <h3>{{ `Bilet na "${webinar.title}"` }}</h3>
                <ul>
                    <li>Materiały dodatkowe do pobrania</li>
                    <li>Zaświadczenie o ukończeniu E-szkolenia</li>
                </ul>
                <div class="item-price">
                    <div>Cena:</div>
                    <div class="-price-crossed" v-if="conference.old_cost">
                        {{
                            `${$Utils.getPriceFromBackend(
                                webinar.old_cost + 199
                            )}zł`
                        }}
                    </div>
                    <div
                        class="black"
                        :class="{
                            '-price-selected': isSelected(webinar.uuid)
                        }"
                    >
                        {{
                            `${$Utils.getPriceFromBackend(
                                webinar.cost + 199
                            )}zł`
                        }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        conference: Object,
        webinar: Object
    },
    data() {
        return {
            selectedItem: {}
        }
    },
    computed: {
        conferenceWebinars() {
            if (!this.conference || !this.conference.uuid) {
                return []
            }
            return this.$store.getters['content/webinarsByConference'](
                this.conference.uuid
            )
        },
        isMobile() {
            return this.$store.getters['source/isMobile']
        }
    },
    methods: {
        isSelected(item) {
            return this.selectedItem.uuid == item
        },
        selectBundle(item) {
            this.selectedItem = item
            this.$emit('itemSelected', item)
        }
    },
    mounted() {
        this.selectBundle(this.conference)
    }
}
</script>
<style lang="scss" scoped>
ul {
    padding: 0 1rem;
}
li {
    margin-bottom: 0.5rem;
}
.vod-summary-title {
    font-size: 2.5rem;
    font-family: $input-family;
}
.summary-image {
    flex: 2;
    margin-left: 1rem;

    img {
        width: 100%;
    }
}
.summary-list {
    font-size: 1.2rem;
    margin-left: 2rem;
    flex: 4;
    line-height: 1.4rem;

    div {
        margin-bottom: 0.2rem;
    }

    h3 {
        margin: 0;
        margin-bottom: 0.5rem;
        font-size: 1.4rem;
        line-height: 1.8rem;
        text-transform: uppercase;
    }
}
.livestream-bundle {
    margin-top: 1rem;
    display: flex;
    border: solid 0.1rem transparent;
    position: relative;
    padding: 2rem 1rem;
    border-radius: $minimal-radius;
    cursor: pointer;
    transition: $ease;

    &::after {
        opacity: 0;
        transition: $ease;
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: -1;
    }

    &.-selected {
        border-color: $accent-apple;

        &::after {
            background: $accent-apple;
            opacity: 0.1;
        }
        &.-purple {
            &::after {
                background: $accent-purple;
                opacity: 0.1;
            }
        }
    }

    &:hover {
        border-color: $accent-apple;
        &::after {
            background: $accent-apple;
            opacity: 0.1;
        }
    }

    &.-purple {
        border-color: $accent-purple;
        &:hover {
            &::after {
                background: $accent-purple;
                opacity: 0.2;
            }
        }
    }
}
.bundle-subtitle {
    position: absolute;
    left: -0.1rem;
    top: -0.1rem;
    background: $accent-purple;
    border-radius: $minimal-radius 0 $minimal-radius 0;
    font-size: 0.7rem;
    font-family: $input-family;
    text-transform: uppercase;
    padding: 0.3rem;
}
.webinars-grid {
    margin-top: -0.2rem;
    flex: 2;
    margin-left: 1rem;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-auto-rows: auto;
    grid-gap: 0rem 1rem;
}
.grid-webinar {
    img {
        object-fit: contain;
        width: 100%;
        height: 100%;
    }
}
.item-price {
    display: inline-flex;
    font-family: $input-family;

    div {
        margin-right: 0.5rem;

        &.-price-crossed {
            color: $accent-grey;
            text-decoration: line-through;
        }
    }
}
@media (max-width: 1000px) {
    .vod-summary-title {
        font-family: $input-family;
        font-size: 1.5rem;
    }
    .summary-list {
        position: relative;
        h3 {
            font-size: 1.1rem;
            font-family: $input-family;
            text-transform: none;
            margin-left: -2rem;
            margin-bottom: -0.2rem;
        }
        ul {
            padding: 0;
            list-style-type: none;
            margin: 0;
            margin-left: -2rem;
            li {
                margin-top: 0.2rem;
                line-height: 90%;
                font-family: $input-family;
                color: $smoked;
                font-size: 1rem;
                &::before {
                    content: '\2022';
                    color: $accent-apple;
                    font-size: 40px;
                    margin-right: 0.3rem;
                    position: relative;
                    top: 0.42rem;
                }
            }
        }
    }
    .webinars-grid {
        grid-template-columns: repeat(1, 1fr);
    }

    .livestream-bundle {
        padding: 1rem;
        padding-bottom: 2rem;
        border-color: $border-accent;

        &.-selected {
            border-color: $action-accent;
            &::after {
                background: none;
            }
        }
    }
    .item-price {
        position: absolute;
        margin-top: 0.2rem;
        right: 0;
        font-size: 1rem;
        font-family: $input-family;
        color: $smoked;
        .black {
            color: black;
        }
        div {
            margin-right: 0.5rem;

            &.-price-selected {
                font-family: $header-family;
                color: $accent-blue;
            }
            &.-price-crossed {
                color: $accent-grey;
                text-decoration: line-through;
            }
        }
    }
}
</style>
